var render, staticRenderFns
import script from "./TrainingWatchlistButton.vue?vue&type=script&lang=js"
export * from "./TrainingWatchlistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdacf2a",
  null
  
)

export default component.exports